/* eslint-disable react/prop-types */
import React from "react";
import classnames from "classnames";
import useStyles from "./TableFields.styles";
import LaunchIcon from "@material-ui/icons/Launch";
import Inbox from "@material-ui/icons/Inbox";
import ReportProblemRoundedIcon from "@material-ui/icons/ReportProblemRounded";
import { ReactComponent as ShoppingBagIcon } from "assets/vectors/shopping_bag.svg";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import { ReactComponent as PendingClockIcon } from "assets/vectors/pending_clock.svg";

import { is_empty } from "features/Common/utils/common.utils";

import Tooltip from "../././../../../../modules/Tooltip";
import { DISPUTES_STATUSES } from "ui/pages/transactions/DisputeHistory/constants/disputes.constant";
import { ActionField } from "common/Components/TableFields/TableFields";
import { getSignedS3DownlaodURL } from "utils/getAccessS3Url";
import {
  CONTRACT_COLUMN,
  CONTRACT_SOURCE,
} from "constants/transactions.constants";
import { navigateToFilteredEInvoiceList } from "ui/pages/transactions/ManageEInvoice/utils/navigateToFilteredEInvoiceList";
export const OfferField = ({ record = {}, source, onClick }) => {
  const classes = useStyles();
  const offer = record[source];
  return (
    <div className={classes.discount_wrapper}>
      {offer ? (
        <div
          className={classes.pointer_cursor}
          onClick={() => onClick(record, source)}
        >
          <div>{offer}</div>
          <LaunchIcon />
        </div>
      ) : (
        "N/A"
      )}
    </div>
  );
};

export const PAYOUT_STATUS = {
  "Added Booking": {
    name: "added_booking",
    icon: <ShoppingBagIcon />,
  },
  Processed: {
    name: "processed",
    icon: (
      <AutorenewRoundedIcon
        preserveAspectRatio="none"
        className="processed_icon"
      />
    ),
  },
  Failed: {
    name: "failed",
    icon: (
      <ReportProblemRoundedIcon
        preserveAspectRatio="none"
        className="failed_icon"
      />
    ),
  },
  Pending: {
    name: "pending",
    icon: <PendingClockIcon />,
  },
  Refunded: {
    name: "refunded",
    icon: (
      <AutorenewRoundedIcon
        preserveAspectRatio="none"
        className="processed_icon"
      />
    ),
  },
  "Refund Initiated": {
    name: "refund_initiated",
    icon: (
      <AutorenewRoundedIcon
        preserveAspectRatio="none"
        className="processed_icon"
      />
    ),
  },
  [DISPUTES_STATUSES.dispute_raised]: {
    name: "dispute_raised",
    icon: <PendingClockIcon />,
    className: "tw-bg-[#FFAB00]",
  },
  [DISPUTES_STATUSES.dispute_document_uploaded]: {
    name: "dispute_document_uploaded",
    icon: (
      <AutorenewRoundedIcon
        preserveAspectRatio="none"
        className="processed_icon"
      />
    ),
    className: "tw-bg-[#00B779]",
  },
  [DISPUTES_STATUSES.dispute_resolved]: {
    name: "won_by_exly",
    icon: (
      <AutorenewRoundedIcon
        preserveAspectRatio="none"
        className="processed_icon"
      />
    ),
    className: "tw-bg-[#00B779]",
  },
  [DISPUTES_STATUSES.dispute_lost]: {
    name: "lost_by_exly",
    icon: (
      <ReportProblemRoundedIcon
        preserveAspectRatio="none"
        className="failed_icon"
      />
    ),
    className: "tw-bg-[#BF2600]",
  },
  [DISPUTES_STATUSES.dispute_reopened]: {
    name: "dispute_reopened",
    icon: <PendingClockIcon />,
    className: "tw-bg-[#FFAB00]",
  },
  [DISPUTES_STATUSES.dispute_accepted]: {
    name: "dispute_accepted",
    icon: (
      <AutorenewRoundedIcon
        preserveAspectRatio="none"
        className="processed_icon"
      />
    ),
    className: "tw-bg-[#00B779]",
  },
};

export const StatusField = ({ record = {}, source }) => {
  const classes = useStyles();
  if (is_empty(record[source])) return <>N/A</>;
  const { name, icon, className } = PAYOUT_STATUS[record[source]] || {};
  return (
    <div
      className={classnames(
        classes.status,
        name && classes[`status_${name}`],
        className
      )}
    >
      {icon}
      <span>{record[source]}</span>
    </div>
  );
};

// TODO: tooltip not working in header of dektop table
export const PayoutFieldHeader = () => (
  <div style={{ minWidth: 111 }}>
    {"Payout Date"}
    <Tooltip
      text={
        "Your payout will be processed by this date from our end; however, it may take up to 48hrs. for the amount to get settled into your bank account"
      }
    />
  </div>
);

// TODO: Empty State UI Pending
export const FilteredEmptyState = () => {
  return (
    <div className="text-center py-5 text-muted">
      <Inbox style={{ fontSize: 60 }} />
      <div>No transactions found!</div>
    </div>
  );
};
export const OfferingPlanNameField = ({ record = {} }) => {
  return (
    <>
      <div>
        {record.session_name || record.listing_name}
        {record.offering_variant_uuid
          ? ` - ${record.offering_variant_title}`
          : ""}
      </div>
      {record.purchased_plan_name ? (
        <div>
          <span style={{ color: "#0052cc" }}>Plan: </span>
          <span>{record.purchased_plan_name}</span>
        </div>
      ) : null}
    </>
  );
};
export const CustomerInvoiceField = ({ record }) => (
  <div className="tw-flex tw-flex-col">
    <ActionField
      label="View Invoice"
      record={record}
      onClick={({ record }) => getSignedS3DownlaodURL(record)}
    />

    {record?.einvoice_enabled && (
      <div
        className="tw-text-[#493ab1] tw-text-[14px] tw-leading-[16px] tw-cursor-pointer hover:tw-underline tw-mt-2"
        onClick={() => {
          navigateToFilteredEInvoiceList(
            record?.transaction_id || record?.uuid
          );
        }}
      >
        Manage E-Invoice
      </div>
    )}
  </div>
);

export const ContractField = ({ record }) => {
  const contractSource = !is_empty(
    record?.[CONTRACT_SOURCE.SIGNED_CONTRACT_PDF]
  )
    ? CONTRACT_SOURCE.SIGNED_CONTRACT_PDF
    : CONTRACT_SOURCE.CONTRACT_SIGNED_URL;
  const hasContract = !is_empty(record?.[contractSource]);

  if (!hasContract) return CONTRACT_COLUMN.EMPTY_VALUE;

  return (
    <ActionField
      label={CONTRACT_COLUMN.VIEW_CONTRACT}
      record={record}
      onClick={({ record }) => getSignedS3DownlaodURL(record, contractSource)}
    />
  );
};
